const GetInTouchInput = ({label, className, placeholder, value, onChange}) => {

    return (
        <div className='git-input-group'>
            <div className='b4 mb-1'>{label}</div>
            {className && className.includes('multi') ? (
                <textarea className={`b4 git-input ${className}`} placeholder={placeholder || label} value={value} onChange={onChange}/>
            ) : (
                <input className={`b4 git-input ${className || ''}`} type="text" placeholder={placeholder || label} value={value} onChange={onChange} />

            )}
        </div>
    );
}

export default GetInTouchInput;